import React, { useState } from 'react'
import { SizeIcon } from '@sainsburys-tech/bolt-icons'
import { FitModal, FitToText } from '../ReviewsSummary/ReviewsSummary'
import * as Styled from './Fit.styles'

const BRAND = process.env.BRAND || 'ARGOS'

const Fit = ({ ratingSummary }) => {
  const { attributes = {} } = ratingSummary || {}
  const { fitDistribution = [], overallFit = {} } = attributes
  const { name: fitName, totalNoOfFitRatings: fitCount, percentage: fitPercentage } = overallFit
  const [show, setShow] = useState(false)

  if (!fitDistribution.length) return null

  return (
    <>
      <Styled.FitButtonContainer
        onClick={() => setShow(!show)}
        onKeyPress={() => setShow(!show)}
        role='link'
        tabIndex='0'
        data-test='pricing-fit-link'
        as={BRAND === 'TU' ? 'button' : 'a'}
        styleTu={BRAND === 'TU'}
      >
        <Styled.FitButtonContent>
          {BRAND === 'TU' && <SizeIcon />}
          <Styled.FitButtonText>
            Fitted {fitPercentage}% of customers {FitToText(fitName)}
          </Styled.FitButtonText>
        </Styled.FitButtonContent>
      </Styled.FitButtonContainer>
      <FitModal {...{ show, setShow, fitDistribution, fitCount, fitName, fitPercentage, dataTest: 'pricing' }} />
    </>
  )
}

export default Fit
